import { StoreAutoComplete } from 'components/autocompletes';
import { useApplicationContext } from 'context/ApplicationContext';
import { FilterValuesProps } from 'hooks/useFilter';
import { usePedidoFilterContext } from 'pages/compra/pedido/contexts/PedidoFilterContext';
import { useSearchParamsFilters } from 'pages/compra/pedido/hooks';
import { LojaProps } from 'pages/compra/pedido/types';

export function PedidoStoreAutoComplete() {
    const { lojaParam } = useSearchParamsFilters();
    const { store } = useApplicationContext();
    const { filterLoja, setFilterLoja, setFilterConfigPedido, setFilterCategoria } = usePedidoFilterContext();

    return (
        <StoreAutoComplete
            fgTipoLoja
            size="small"
            value={filterLoja.value}
            defaultStore={!lojaParam && store.fgAtivo}
            requestOptions={{
                url: '/gestao/loja',
                sort: [{ property: 'dsNomeFantasia', direction: 'ASC' }],
                filter: [{ property: 'fgAtivo', value: true, operator: 'eq' }],
                columns: 'idLoja,cdLoja,dsNomeFantasia,dsRazaoSocial',
                limit: 50,
            }}
            onChange={(e, value: LojaProps) => {
                setFilterConfigPedido((oldState: FilterValuesProps) => ({ ...oldState, value: null }));
                setFilterCategoria((oldState: FilterValuesProps) => ({ ...oldState, value: null }));
                setFilterLoja((oldState: FilterValuesProps) => ({
                    ...oldState,
                    value: value && { idLoja: value.idLoja, cdLoja: value.cdLoja, dsNomeFantasia: value.dsNomeFantasia },
                }));
            }}
        />
    );
}
